import classNames from 'classnames'
import React from 'react'
import HtmlContent from '../HtmlContent'
import style from './styles/errorText.module.scss'

const ErrorAllText = ({ text = '', className = '' }): React.ReactElement => {
  return (
    <div className={classNames({
      [style.error__all]: true,
      [className]: Boolean(className)
    })}
    >
      <HtmlContent content={text} />
    </div>
  )
}

export default ErrorAllText
